import { useLocation } from "react-router-dom";
import Seo from "../Components/Seo";
import { staticSeoByPath } from "../config/staticSeo";
import { parseListPage } from "../utils/listPagePath";

/**
 * Static list SEO: match bare path, and reuse that entry for /p/{n}.
 * Page 1 canonical stays the bare list path; page 2+ is self-canonical.
 */
const PageSeo = () => {
  const { pathname } = useLocation();
  const { basePath, page } = parseListPage(pathname);
  const entry = staticSeoByPath[basePath] || staticSeoByPath[pathname];

  if (!entry) return null;

  const logdetails: string[] = [];
  logdetails.push("action=page_seo_resolve");
  logdetails.push(`pathname=${pathname}`);
  logdetails.push(`basePath=${basePath}`);
  logdetails.push(`page=${page}`);

  // Page 1 keeps sitemap/static canonical; later pages point at /p/{n}
  const canonicalPath =
    page <= 1 ? entry.path || basePath : `${basePath}/p/${page}`;
  const titleSuffix = page > 1 ? ` - Page ${page}` : "";
  const title = entry.title ? `${entry.title}${titleSuffix}` : entry.title;
  const ogTitle = entry.ogTitle
    ? `${entry.ogTitle}${titleSuffix}`
    : entry.ogTitle;

  logdetails.push(`canonicalPath=${canonicalPath}`);
  logdetails.push(`title=${title || ""}`);
  console.log("PageSeo ->", logdetails.join(" | "));

  return (
    <Seo
      title={title}
      description={entry.description}
      ogTitle={ogTitle}
      ogDescription={entry.ogDescription}
      keywords={entry.keywords}
      path={canonicalPath}
      image={entry.image}
      ogType={entry.ogType}
      ogImageType={entry.ogImageType}
      ogImageWidth={entry.ogImageWidth}
      ogImageHeight={entry.ogImageHeight}
      siteName={entry.siteName}
      locale={entry.locale}
      localeAlternate={entry.localeAlternate}
      articlePublisher={entry.articlePublisher}
      robots={entry.robots}
      author={entry.author}
      publisher={entry.publisher}
      themeColor={entry.themeColor}
      htmlLang={entry.htmlLang}
      twitterSite={entry.twitterSite}
      twitterCreator={entry.twitterCreator}
      alternates={entry.alternates}
      iconHref={entry.iconHref}
      appleTouchIconHref={entry.appleTouchIconHref}
      jsonLd={entry.jsonLd}
      fbAppId={entry.fbAppId}
    />
  );
};

export default PageSeo;
